import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BaseComponent } from '../base/base.component';
import {VersionManagerPipe} from "@wms/core";

@Component({
  selector: 'wms-live-list-field-config',
  standalone: true,
  templateUrl: './live-list-field-config.component.html',
  styleUrls: ['./live-list-field-config.component.less'],
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule,
    VersionManagerPipe,
  ]
})
export class LiveListFieldConfigComponent extends BaseComponent implements OnInit {
  @Input() templateWidgets!: any;
  @Input() selectedWidget!: any;
  @Input() listImage!: string;
  @Input() fields!: any;
  @Output() selectTemplateWidget = new EventEmitter<any>();
  @Output() setWidgetProp = new EventEmitter<any>();
  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  onTemplateWidgetSelect(widget: any) {
    this.selectTemplateWidget.emit(widget)
  }

  updateWidgetProps(prop: any) {
    this.setWidgetProp.emit(prop);
  }

}
